import ManageUsers from './ManageUsers.container';

export default ManageUsers;
